import * as Sentry from '@sentry/react';

// Reports only values known to be safe. Sentry's extraErrorData integration
// is deliberately not used here: it serialises an error's own enumerable
// properties, which for an axios error include `config.data` (the request
// payload) and `config.headers` (auth tokens). The default integrations
// serialise only an Error's name, message and stack, so passing the error
// object itself cannot leak the request.
const isClientErrorStatus = (status: unknown): boolean =>
  typeof status === 'number' && status >= 400 && status < 500;

export const captureRequestError = (error: unknown): void => {
  const { config, response } = (error as any) ?? {};

  // 4xx responses are expected client outcomes (validation, permissions),
  // so only server faults and transport failures are reported.
  if (isClientErrorStatus(response?.status)) {
    return;
  }

  Sentry.captureException(error, {
    tags: { source: 'platform-request' },
    contexts: {
      platformRequest: {
        method: config?.method,
        url: config?.url,
        status: response?.status,
      },
    },
  });
};
